import { configProduction, sharedFields } from './environmentsProd';

import type { Config } from './configType';

// Staging, Sandbox, Dev, Local envs

// Golden Config Staging v6
export const configStaging = {
  ...sharedFields,
  // intercomId: 'upnml9ft', // Test
  env: 'staging',
  envIsSandbox: true,
  turnstileCaptchaSiteKey: '0x4AAAAAAALCW0bfNeRbnmZn',
  delegatedKeyExpirationDays: 16,
  chains: {
    // Faucet https://core.app/tools/testnet-faucet/?subnet=c&token=c
    avalanche: {
      chainNetwork: 'Avalanche-Fuji Testnet',
      chainBlockExplorer: 'https://testnet.avascan.info/blockchain/c',
      chainId: 43113,
      chainCurrency: 'AVAX',
      chainRpc: 'https://api.avax-test.network/ext/bc/C/rpc',
      chainRpcSoftwareWallet: true,
      depositNotAvailable: true,
      usdcTokenAddress: '0x89C1D24fFb34020a9Be5463bD2578fF966E9f303',
    },
    arbitrum: {
      chainNetwork: 'Arbitrum-Sepolia Testnet',
      chainBlockExplorer: 'https://sepolia.arbiscan.io',
      chainId: 421614,
      chainCurrency: 'ETH',
      chainRpc:
        'https://arb-sepolia.g.alchemy.com/v2/Mb9MWMHYaVtzPEzAmo_UCdUHdtRyrSvj', // 'https://arbitrum-sepolia.blockpi.network/v1/rpc/public',
      chainRpcSoftwareWallet: true,
      usdcTokenAddress: '0x3253a335E7bFfB4790Aa4C25C4250d206E9b9773',
      preferredChain: true,
    },
    baseEVM: {
      chainNetwork: 'Base-Sepolia Testnet',
      chainBlockExplorer: 'https://base.blockscout.com',
      chainId: 84532,
      chainCurrency: 'ETH',
      chainRpc:
        'https://base-sepolia.g.alchemy.com/v2/xAMyz0EAIKlYUXnQOW4xvXZeh0PVF5QB',
      chainRpcSoftwareWallet: true,
      averageBlockTimeSec: 2,
      depositPaused: true,
      usdcTokenAddress: undefined,
      preferredChain: true,
    },
    beraChain: {
      chainNetwork: 'cArtio (Bera) Testnet',
      chainBlockExplorer: 'https://80000.testnet.routescan.io',
      chainId: 80000,
      chainCurrency: 'BERA',
      chainRpc: 'https://teddilion-eth-cartio.berachain.com', // 'https://rockbeard-eth-cartio.berachain.com',
      chainRpcSoftwareWallet: true,
      averageBlockTimeSec: 2,
      // Alternative: Collateral (USDC OFTAdapter) cArtio L1	0xb1487b8C46e68e15ed3B01cC5AA4A1E6aFEfd6d4
      usdcTokenAddress: '0x015fd589F4f1A33ce4487E12714e1B15129c9329', // Collateral (USDC) cArtio L1
      preferredChain: true,
      depositNotAvailable: true, // On testnet we use Sepolia only
    },
    bnbSmartChain: {
      chainBlockExplorer: 'https://testnet.bscscan.com',
      chainId: 97,
      chainNetwork: 'BSC Testnet',
      chainCurrency: 'BNB',
      chainRpc: 'https://data-seed-prebsc-1-s1.binance.org:8545',
      chainRpcSoftwareWallet: true,
      depositNotAvailable: true,
      averageBlockTimeSec:
        configProduction.chains.bnbSmartChain.averageBlockTimeSec,
      usdcTokenAddress: undefined,
    },
    ethereum: {
      chainId: 11155111,
      chainNetwork: 'Eth-Sepolia Testnet',
      chainCurrency: 'ETH',
      chainRpc:
        'https://eth-sepolia.g.alchemy.com/v2/xAMyz0EAIKlYUXnQOW4xvXZeh0PVF5QB',
      chainRpcSoftwareWallet: true,
      chainBlockExplorer: 'https://sepolia.etherscan.io',
      usdcTokenAddress: '0x2F6F07CDcf3588944Bf4C42aC74ff24bF56e7590',
      preferredChain: true,
      depositNotAvailable: true,
      // devBgtRewardVaultAddress: '0x9694b8dD1E0a321FE2308Ab95AA0EEE6F741207a', // KRT Reward Vault on Sepolia
    },
    // https://bridge.katana.network/
    katanaChain: {
      chainId: 737373,
      chainNetwork: 'Katana Bokuto Testnet',
      chainCurrency: 'ETH',
      chainRpc: 'https://rpc-bokuto.katanarpc.com',
      chainRpcSoftwareWallet: true,
      chainBlockExplorer: 'https://bokuto.katanascan.com',
      usdcTokenAddress: '0xc2a4C310F2512A17Ac0047cf871aCAed3E62bB4B',
      // usdcTokenSymbolOverride: 'vbUSDC',
      restApiUrl: 'https://api-staging.katana-perps-dev.com/v1',
      webSocketApiUrl: 'wss://websocket-staging.katana-perps-dev.com/v1',
      averageBlockTimeSec: 1,
      blocksConfirmation: 1,
      exchangeContract: '0x4C234fCeA3f8c4C8a7D962a6d8f2214f6ab1D5c4',
      stargateAdapterV3Address: '0x99ef9E11c6Abe1150A50dfe3d059299e97Cf9ECD',
      stargateJumpChain: 'ethereum',
      stargateJumpChainForwarderAddress: '', // TODO: katana bridging
      localDepositAdapterV1KatanaContractAddress:
        '0xE827DABDE1A661AaE17bD4c18f9afA9bbb1aAfB8',
      loopbackBridgeAdapterV1KatanaContractAddress:
        '0x9c628B71CC279Aa25E32d5410aCb1E0A16C07793',

      // TODO: katana vaults config (not initial release)
      fixedIncomeVaultProviderAddress:
        '0x85Ea9016acdEc997338F92B3E1256E9ae4aC9411',
      // profitShareVaultProviderAddress: '',
      // Removed - the `stateAggregator` address comes from the vaults API response
      // fixedIncomeVaultProviderStateAggregatorAddress:
      //   '0xe5dbbe576c78EFa8b978969a84D76F87223ed4Ca',
      fixedIncomeVaultMinInterestMultiplier: 0n,
      fixedIncomeVaultMaxInterestMultiplier: 1000000000n,
      fixedIncomeVaultMaxNetDeposits: 18446744073709551615n,
      fixedIncomeVaultMinNetDeposits: 10000000000n,
      fixedIncomeVaultMinWithdrawalLimitPercentForVault: 0n,
      fixedIncomeVaultMaxWithdrawalLimitPercentForVault: 100000000n,
      fixedIncomeVaultMinWithdrawalLimitPercentForDepositors: 10000000n,
      fixedIncomeVaultMaxWithdrawalLimitPercentForDepositors: 100000000n,
      fixedIncomeVaultMinExitThresholdMultiplier: 50000000n,
      fixedIncomeVaultMaxExitThresholdMultiplier: 200000000n,
      fixedIncomeVaultMinWithdrawalThresholdMultiplier: 50000000n,
      fixedIncomeVaultMaxWithdrawalThresholdMultiplier: 999999999n,
      fixedIncomeVaultMinDepositWithdrawalExitAgeInS: 3600n,
      fixedIncomeVaultMaxDepositWithdrawalExitAgeInS: 2419200n,
    },
    mantle: {
      chainId: 5001,
      chainNetwork: 'Mantle Testnet (not available)',
      chainCurrency: 'MNT',
      chainRpc: '#noRpc',
      chainRpcSoftwareWallet: true,
      chainBlockExplorer: '#notAvailable',
      depositPaused: true,
      depositNotAvailable: true,
      usdcTokenAddress: '0x123',
    },
    optimism: {
      chainNetwork: 'Optimism-Sepolia Testnet',
      chainBlockExplorer: 'https://sepolia-optimistic.etherscan.io',
      chainId: 11155420,
      chainCurrency: 'ETH',
      chainRpc: 'https://sepolia.optimism.io',
      chainRpcSoftwareWallet: true,
      depositPaused: true,
      usdcTokenAddress: '0x488327236B65C61A6c083e8d811a4E0D3d1D4268',
      preferredChain: true,
    },
    polygonPoS: {
      // Most likely not work as Mumbai is deprecated
      chainNetwork: 'Polygon-Mumbai Testnet',
      chainId: 80001,
      chainCurrency: 'POL',
      chainRpc:
        // https://polygon-amoy.g.alchemy.com/v2/xAMyz0EAIKlYUXnQOW4xvXZeh0PVF5QB
        'https://polygon-mumbai.g.alchemy.com/v2/AQvF7X06a70rZ133zHTSLh7Rqg6-_YeT',
      chainRpcSoftwareWallet: true,
      chainBlockExplorer: 'https://mumbai.polygonscan.com',
      depositNotAvailable: true,
      averageBlockTimeSec: 3,
      usdcTokenAddress: '0x742DfA5Aa70a8212857966D491D67B09Ce7D6ec7',
    },
    seiChain: {
      chainNetwork: 'Sei Testnet (Not setup)',
      chainId: 12345,
      chainCurrency: 'SEI',
      chainRpc: 'https://unknown',
      chainRpcSoftwareWallet: true,
      chainBlockExplorer: 'https://unknown',
      depositNotAvailable: true,
      averageBlockTimeSec: 1,
      depositPaused: true,
      usdcTokenAddress: '0xunknown',
    },
  },
} satisfies Config;

// Golden Config Sandbox v4
export const configSandbox = {
  ...sharedFields,
  // intercomId: configProduction.intercomId,
  env: 'sandbox',
  envIsSandbox: true,
  turnstileCaptchaSiteKey: configProduction.turnstileCaptchaSiteKey,
  delegatedKeyExpirationDays: 30,
  chains: {
    ...configStaging.chains,
    ethereum: {
      ...configStaging.chains.ethereum,
      usdcTokenAddress: '0xCea1D25a715eC34adFB2267ACe127e8D107778dd',
    },
    katanaChain: {
      ...configStaging.chains.katanaChain,
      restApiUrl: 'https://api-perps-sandbox.katana.network/v1',
      webSocketApiUrl: 'wss://websocket-perps-sandbox.katana.network/v1',
      exchangeContract: '0x92d3072dDe1aD3e9B7895500F504aA5e664E71d3',
      stargateAdapterV3Address: '0x00bB35eB9Ec6B4D53414c605692D282624705bCe',
      stargateJumpChain: 'ethereum',
      stargateJumpChainForwarderAddress: '',
      localDepositAdapterV1KatanaContractAddress:
        '0x65b9a7F10C0C984dB118435FA974eA80a5896ee7',
      loopbackBridgeAdapterV1KatanaContractAddress:
        '0xDE62F969FD05D2fA90B227E4055B658CFCf3E625',
      fixedIncomeVaultProviderAddress:
        '0x9304FEeCa70694B5d9BeFEB5577EF6182f158CeB',
      // profitShareVaultProviderAddress: '',
      // fixedIncomeVaultProviderStateAggregatorAddress:
      //   '0xA494A05bF08b3630156678A7aE11983ef8114Bf0',
    },
  },
} satisfies Config;

// Kuma reward token 0x273c832797Bfda1C0826a786670D041282Bd6aFc

export const configDev = {
  ...sharedFields,
  widgetsSubdomain: false,
  // intercomId: 'upnml9ft', // Test
  env: 'test',
  envIsSandbox: true,
  turnstileCaptchaSiteKey: configStaging.turnstileCaptchaSiteKey,
  delegatedKeyExpirationDays: 16,
  chains: {
    ...configStaging.chains,
    ethereum: {
      ...configStaging.chains.ethereum,
      usdcTokenAddress: '0xCea1D25a715eC34adFB2267ACe127e8D107778dd',
    },
    katanaChain: {
      ...configStaging.chains.katanaChain,
      restApiUrl: 'https://api-dev.katana-perps-dev.com/v1',
      webSocketApiUrl: 'wss://websocket-dev.katana-perps-dev.com/v1',
      exchangeContract: '0x18F7966C93C5b5d24Dbc7a1425FCe6cf5ebAa5e0',
      stargateAdapterV3Address: '0xC4713c249160305b3aE772862031929a52942D0A',
      localDepositAdapterV1KatanaContractAddress:
        '0x4Ef81360dE00B9f1f32847404C0D036FC6860F92',
      fixedIncomeVaultProviderAddress:
        '0x46b4C417FFf61d14A6c398A04008d3eF65217E33',
      // fixedIncomeVaultProviderStateAggregatorAddress:
      //   '0x34e1055Dea59e2AA3C8e3F6D552FAd225638671D',
      loopbackBridgeAdapterV1KatanaContractAddress:
        '0x604158631FD3FD63B2a9bF266350d979D98c3437',
    },
  },
} satisfies Config;

export const configLocalhost = {
  ...configDev,
  env: 'local', // 'local' | 'production',
  widgetsSubdomain: false,
  chains: {
    ...configDev.chains,
    katanaChain: {
      ...configDev.chains.katanaChain,
      restApiUrl: 'http://localhost:3001/v1',
      webSocketApiUrl: 'ws://localhost:9394/v1',
      chainRpc: 'http://localhost:3001/rpc',
      chainRpcSoftwareWallet: true,
      // On-chain reads are faked by the mock server /rpc endpoint - addresses
      // only need to be valid, obviously-fake values (mirrored in the mock
      // server exchange response)
      localDepositAdapterV1KatanaContractAddress:
        '0x0000000000000000000000000000000000000001',
      loopbackBridgeAdapterV1KatanaContractAddress:
        '0x0000000000000000000000000000000000000002',
      fixedIncomeVaultProviderAddress:
        '0x0000000000000000000000000000000000000003',
      // stateAggregator now comes from the mock vaults API response
      // (0x0000000000000000000000000000000000000004 in fakeVaultsData)
    },
  },
} satisfies Config;

export const configLocalhostDev = {
  ...configStaging,
  env: 'local',
  chains: {
    ...configStaging.chains,
    katanaChain: {
      ...configStaging.chains.katanaChain,
      chainId: 1001,
      chainNetwork: 'Private Testnet',
      chainRpc: 'https://explorer-dev-geth.kuma-dev.com:8545',
      chainRpcSoftwareWallet: true,
      chainBlockExplorer: 'https://explorer-dev-geth.kuma-dev.com',
      webSocketApiUrl: 'ws://exchange-local.kuma-dev.com:9394/v1',
      restApiUrl: 'https://exchange-local-private.kuma-dev.com:3001/v1',
      // this should be overwritten based on your local env
    },
  },
} satisfies Config;
